/**
 * BSSLogo - Official BSS Portal brand lockup.
 * Asset: /bss-logo.png (blue "BSS" mark + PORTAL wordmark, transparent bg).
 * Works on both light and dark surfaces.
 *
 * Props:
 *  - size: rendered height in px
 *  - variant / showText / invert: kept for API compatibility (asset already
 *    contains the full lockup, so all variants render the same image)
 */
const RATIO = 1651 / 1316; // width / height of the lockup asset

export const BSSLogo = ({ size = 40, testId = "bss-logo" }) => (
  <img
    src="/bss-logo.png"
    alt="BSS Portal"
    data-testid={testId}
    draggable={false}
    style={{ height: size, width: size * RATIO, display: "block", objectFit: "contain" }}
  />
);

export default BSSLogo;
